/**
 * Loading Manager Types (JSDoc)
 *
 * @typedef {'route' | 'query' | 'mutation' | 'bootstrap'} LoadingType
 *
 * @typedef {'success' | 'cancelled' | 'timeout' | 'aborted'} CompletionReason
 *
 * @typedef {'pending' | 'success'} LoadingStatus
 *
 * @typedef {Object} LoadingEntry
 * @property {string} id
 * @property {LoadingType} type
 * @property {string} [source]
 * @property {string} [message]
 * @property {LoadingStatus} status
 * @property {number} startedAt
 * @property {number} [progress]
 *
 * @typedef {Object} LoadingManagerState
 * @property {boolean} active
 * @property {boolean} routeLoading
 * @property {boolean} queryLoading
 * @property {boolean} mutationLoading
 * @property {boolean} bootstrapLoading
 * @property {LoadingEntry[]} entries
 * @property {number} count
 * @property {number} routeProgress
 *
 * @typedef {Object} LoadingHistoryEntry
 * @property {string} id
 * @property {LoadingType} type
 * @property {string} source
 * @property {number} startedAt
 * @property {number} finishedAt
 * @property {number} duration
 * @property {CompletionReason} reason
 *
 * @typedef {Object} StartLoadingOptions
 * @property {string} [source]
 * @property {string} [message]
 *
 * @typedef {Object} MutationOptions
 * @property {(...args: any[]) => Promise<any>} mutationFn
 * @property {Array[]} [invalidateKeys]
 * @property {(data: any) => void} [onSuccess]
 * @property {(error: Error) => void} [onError]
 * @property {string} [source]
 * @property {string} [message]
 *
 * @typedef {Object} MutationHandle
 * @property {boolean} pending
 * @property {LoadingStatus} status
 * @property {any} data
 * @property {Error|null} error
 * @property {(...args: any[]) => Promise<any>} execute
 * @property {() => void} reset
 */

export const LoadingType = /** @type {const} */ ({
  Query: 'query',
  Route: 'route',
  Mutation: 'mutation',
  Bootstrap: 'bootstrap',
})

export {}
